import $ from 'jquery';
export default {
	init() {
    const calculateBudget = () => {
      const amountInput = $('[data-key="field_5e998cc328581"] input').val();
      const companyPricePerFollowerItem = $('[data-key="field_6184e4ed6efbf"] input');
      if (amountInput && parseInt(amountInput, 10) > 0) {
          let companyPricePerFollowerValue = 0.6;
          if (companyPricePerFollowerItem) {
            companyPricePerFollowerValue = parseFloat(companyPricePerFollowerItem.val());
          }
          let totalFollowers = parseInt(amountInput) / companyPricePerFollowerValue;
          totalFollowers = Math.floor(totalFollowers, 0);

          let costFollowers = window.acf.getField('field_5ee0eba0c555f');
          costFollowers.val(totalFollowers);
          window.acf.set('number_followers', totalFollowers);
      }
    }

    const postType = window.acf.get('post_type');
		if(postType === 'campaign' && $('body.post-new-php').length){
      // Approved disabled
      $('[data-key="field_5eb8f3172bf06"] input').attr('disabled', 'disabled');
      $('[data-key="field_5eb8f3172bf06"] input').css('backgroundColor', '#eee');

      // SEK / follower disabled
      $('[data-key="field_5ef31a35b4b12"] input').attr('disabled', 'disabled');
      $('[data-key="field_5ef31a35b4b12"] input').css('backgroundColor', '#eee');

      // Nbr of followers
      $('[data-key="field_5ee0eba0c555f"] input').attr('disabled', 'disabled');
      $('[data-key="field_5ee0eba0c555f"] input').css('backgroundColor', '#eee');

      // On budget input
      $('[data-key="field_6184e4ed6efbf"] input').on('input', calculateBudget);
      $('[data-key="field_5e998cc328581"] input').on('input', calculateBudget);
    }
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
